import { getStoreId, setStoreId } from "$/hooks/use-store-information"
import { determineStoreId } from "$/lib/determine-store-id"
import env from "$/lib/env"
import firebaseConfig from "$/lib/firebase-config.ts"
import { isClientStale } from "$/lib/is-client-stale"
import { createWebAuth } from "@repo/web-auth"
import { captureException, captureMessage, flush, setUser } from "@sentry/react"

// Arrow wrappers rather than the bindings themselves: use-store-information
// imports this module (via user-queries), so its exports are not yet
// initialised while this one evaluates.
export const webAuth = createWebAuth({
  appName: "CRM",
  apiUrl: env.VITE_API_URL,
  firebase: firebaseConfig,
  authEmulatorHost: env.VITE_FIREBASE_AUTH_EMULATOR_HOST,
  isClientStale,
  reporter: {
    captureException: (error) => captureException(error),
    captureMessage: (message, context) => captureMessage(message, context),
    flush: (timeoutMs) => flush(timeoutMs),
    setUser: (user) => setUser(user),
  },
  storeScope: {
    getStoreId: () => getStoreId(),
    setStoreId: (storeId) => setStoreId(storeId),
  },
  onLogin: (user, { authRequest }) => determineStoreId(user, authRequest),
})

export const {
  findIdToken,
  login,
  logoutActiveAccount,
  getCurrentUser,
  resetPassword,
  reportTokenLostOnLoad,
  listAccounts,
  getActiveAccountEmail,
  switchAccount,
  removeAccount,
} = webAuth
